import { useQueryClient } from "@tanstack/react-query"
import { createContext, PropsWithChildren, useContext } from "react"
import { getAllServices } from "./services"

type ContextServices = ReturnType<typeof getAllServices>

export const ServicesContext = createContext<ContextServices>({} as ContextServices)

/**
 * This context provider is used to provide all services to the application.
 * It is used in the root of the application.
 * The getAllServices accepts an object of services to override the default ones.
 * This is useful for testing purposes and injecting fake services.
 * @example getAllServices({ customBenchmarkApi: new FakeBenchmarkApi() })
 */

export const ServicesContextProvider = ({ children }: PropsWithChildren) => {
  const customQueryClient = useQueryClient()
  // const customProgramApi = new FakeProgramApi()
  // customProgramApi.programs = PROGRAM_TEST_DATA.INFINITE.PROGRAMS

  // const customInfiniteProgramApi = new FakeInfiniteProgramApi()
  // customInfiniteProgramApi.programs = PROGRAM_TEST_DATA.INFINITE.PROGRAMS

  // const customSharedUserApi = new FakeUserProfileApi()
  // customSharedUserApi.user = USER_TEST_DATA.COACH

  // const customBoxSlotApi = new FakeBoxSlotApi()
  // const customBoxPlanningApi = new FakeBoxPlanningApi()

  // const customPersonalRecordsApi = new FakePersonalRecordsApi()
  // const customMemberApi = new FakeMemberApi()

  return (
    <ServicesContext.Provider
      value={getAllServices({
        customQueryClient,
        // customMemberApi,
        // customProgramApi,
        // customInfiniteProgramApi,
        // customSharedUserApi,
        // customBoxSlotApi,
        // customBoxPlanningApi,
        // customPersonalRecordsApi,
      })}
    >
      {children}
    </ServicesContext.Provider>
  )
}

export const useServicesContext = () => useContext(ServicesContext)
